import React, { useState, useEffect } from 'react';

const ChatWidget = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    // Fade in effect when component mounts
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const openWhatsApp = () => {
        window.open('https://wa.me/+923330348378', '_blank'); // Replace with your WhatsApp number
    }; const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        zIndex: 1000,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    };

    const iconStyle = {
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
    };

    const textStyle = {
        color: '#075E54', // WhatsApp dark green color for text
        padding: '0 12px',
        fontSize: '15px',
        fontWeight: '500',
        transition: 'all 0.3s ease',
        transform: isHovered ? 'translateX(5px)' : 'translateX(0)',
        whiteSpace: 'nowrap',
    };

    const whatsappIconStyle = {
        width: '50px',
        height: '50px',
        transition: 'transform 0.3s ease',
        transform: isHovered ? 'rotate(10deg)' : 'rotate(0)',
    };
    return (
        <>
            <style>
                {`
                    .chat-widget-container {
                        position: fixed;
                        bottom: 25px;
                        left: 25px;
                    }
                    @media (max-width: 991px) {
                        .chat-widget-container {
                            bottom: 90px !important;
                        }
                    }
                `}
            </style>
            <div
                className="chat-widget-container"
                style={containerStyle}
                onClick={openWhatsApp}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div style={iconStyle}>
                    <img
                        src="/assets/whatsapp.png"
                        alt="WhatsApp"
                        style={whatsappIconStyle}
                    />
                </div>

            </div>
        </>
    );
};

export default ChatWidget;
